import { RouterState } from '@angular/router';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const routerState: any = createFeatureSelector<RouterState>('router');

export const navigationEnd = createSelector(routerState, (state: any) => {
  return state.label;
});

export const curPage = createSelector(routerState, (state: any) => {
  return state.curPage;
});

export const currentPage = createSelector(routerState, (state: any) => {
  return state.currentPage;
});
